// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.98-TSS-3101-mcastro-IMPROVEMENT-PHASE-01-Filter-changed-placements-when-opening-a-variation-email.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
